import React, { useState, useEffect, useCallback } from 'react';

const GAP = 12;
const BORDER_RADIUS = 16;
const MASK_ID = 'tour-blur-mask';

const TourBlurBackdrop = ({ open, targetSelector }) => {
  const [cutout, setCutout] = useState(null);
  const [viewportSize, setViewportSize] = useState({
    w: window.innerWidth,
    h: window.innerHeight,
  });

  const updateCutout = useCallback(() => {
    setViewportSize({ w: window.innerWidth, h: window.innerHeight });

    if (!targetSelector) {
      setCutout(null);
      return;
    }

    // Pick the first VISIBLE match — desktop/mobile duplicates share selectors and
    // the hidden one (display:none) would otherwise win via querySelector.
    const all = document.querySelectorAll(targetSelector);
    let el = null;
    for (const candidate of all) {
      if (candidate.getClientRects().length) { el = candidate; break; }
    }
    if (!el) {
      setCutout(null);
      return;
    }

    const rect = el.getBoundingClientRect();
    setCutout({
      x: rect.x - GAP,
      y: rect.y - GAP,
      width: rect.width + GAP * 2,
      height: rect.height + GAP * 2,
    });
  }, [targetSelector]);

  useEffect(() => {
    if (!open) return;

    updateCutout();

    window.addEventListener('scroll', updateCutout, true);
    window.addEventListener('resize', updateCutout);
    // Poll too: async layout shifts (e.g. the top-bar Invite avatars loading late and
    // pushing the "show in my brand" toggle sideways) fire no scroll/resize event, so
    // the cutout would otherwise stay glued to the target's stale position.
    const iv = setInterval(updateCutout, 250);

    return () => {
      window.removeEventListener('scroll', updateCutout, true);
      window.removeEventListener('resize', updateCutout);
      clearInterval(iv);
    };
  }, [open, updateCutout]);

  if (!open) return null;

  return (
    <>
      <svg width="0" height="0" style={{ position: 'absolute', pointerEvents: 'none' }}>
        <defs>
          <mask id={MASK_ID} maskUnits="userSpaceOnUse" x="0" y="0" width={viewportSize.w} height={viewportSize.h}>
            <rect width={viewportSize.w} height={viewportSize.h} fill="white" />
            {cutout && (
              <rect
                x={cutout.x}
                y={cutout.y}
                width={cutout.width}
                height={cutout.height}
                rx={BORDER_RADIUS}
                fill="black"
              />
            )}
          </mask>
        </defs>
      </svg>
      <div
        className="tour-blur-backdrop"
        style={{
          WebkitMask: `url(#${MASK_ID})`,
          mask: `url(#${MASK_ID})`,
        }}
      />
    </>
  );
};

export default TourBlurBackdrop;
